import { useEffect, useState } from "react";
import "@/App.css";
import Lenis from "lenis";
import { AnimatePresence, motion } from "framer-motion";
import PresentationIntro from "@/components/PresentationIntro";
import ConceptSwitcher from "@/components/ConceptSwitcher";
import ConceptA from "@/components/ConceptA";
import ConceptB from "@/components/ConceptB";
import CatalogRFQ from "@/components/CatalogRFQ";
import StaffAdmin from "@/components/StaffAdmin";
import Proposal from "@/components/Proposal";
import { CATALOG, PRICES } from "@/data/content";

function App() {
  const [initialSession] = useState(() => new URLSearchParams(window.location.search).get("session_id"));
  const [concept, setConcept] = useState(() =>
    new URLSearchParams(window.location.search).get("view") === "proposal" ? "proposal" : null
  );
  const [products, setProducts] = useState(() =>
    CATALOG.map((p) => ({ ...p, basePrice: PRICES[p.id], status: "In Stock", visible: true }))
  );

  useEffect(() => {
    window.scrollTo(0, 0);
    const lenis = new Lenis({ lerp: 0.09 });
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
    };
  }, [concept]);

  return (
    <div className="App">
      <AnimatePresence mode="wait">
        <motion.div
          key={concept ?? "intro"}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.45, ease: "easeOut" }}
        >
          {concept === null && <PresentationIntro onSelect={setConcept} />}
          {concept === "a" && <ConceptA />}
          {concept === "b" && <ConceptB />}
          {concept === "catalog" && <CatalogRFQ products={products} />}
          {concept === "admin" && (
            <StaffAdmin products={products} onSave={setProducts} onViewCatalog={() => setConcept("catalog")} />
          )}
          {concept === "proposal" && <Proposal sessionId={initialSession} />}
        </motion.div>
      </AnimatePresence>
      <ConceptSwitcher concept={concept} onSelect={setConcept} />
    </div>
  );
}

export default App;
